import { render, staticRenderFns } from "./BtDateFormatDefiner.vue?vue&type=template&id=061e1b04&"
import script from "./BtDateFormatDefiner.vue?vue&type=script&lang=js&"
export * from "./BtDateFormatDefiner.vue?vue&type=script&lang=js&"
import style0 from "./BtDateFormatDefiner.vue?vue&type=style&index=0&id=061e1b04&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports